import SystemAdministrationRoutes from "./SystemAdministration";
import DispatchProcessingRoutes from "./DispatchProcessing";
import FleetManagementRoutes from "./FleetManagement";
import AccountingRoutes from "./Accounting";
import InventoryManagementRoutes from "./InventoryManagement";
import HRManagement from "./HRManagement";
import PTOProcessingRoutes from "./PTOProcessing";

export default [
  SystemAdministrationRoutes,
  DispatchProcessingRoutes,
  AccountingRoutes,
  FleetManagementRoutes,
  HRManagement,
  InventoryManagementRoutes,
  PTOProcessingRoutes
];
